import { getAppConfig } from '@utils/getAppConfig'

export interface GetAlternativeProductApplicationUrlOptions {
    adg?: string
    cam?: string
    clickId: string
    clickSource: string
    customerId: string
    gclid?: string
    isKnownCustomer: string
    m?: string
    productCode: string
    scoreId: string
    visitGuid: string
}

export const getAlternativeProductApplicationUrl = (
    options: GetAlternativeProductApplicationUrlOptions
): string => {
    const appConfig = getAppConfig()

    const searchQuery = {
        csrc: options.clickSource,
        ccid: options.productCode,
        customerOrigin: 'Account',
        customerId: options.customerId,
        scoreId: options.scoreId,
        clickId: options.clickId,
        customerType: 'Account',
        isKnownCustomer: options.isKnownCustomer,
        m: options.m,
        cam: options.cam,
        adg: options.adg,
        visitGuid: options.visitGuid,
        gclid: options.gclid,
        platform: 'web',
    } as const

    const url = new URL(appConfig.CLICK_OUT_URL)

    Object.keys(searchQuery).forEach(searchKey => {
        const sk = searchKey as keyof typeof searchQuery
        url.searchParams.append(sk, searchQuery[sk]!)
    })

    return url.toString()
}
